// extracted by mini-css-extract-plugin
module.exports = {"podcastWidget":"fbBxQ","heading":"VbFRs","podcastInner":"U8b7Q","pageHeader":"fY6xQ","text":"ppyAT","slider":"A_lL7"};